'use strict';

SearchPreprocessorFactory.$inject = ['mx.shell.SearchProviderService', 'mx.SolutionBuilderAgent.BasePreprocessor'];
export default function SearchPreprocessorFactory(searchService, BasePreprocessor) {
	function SearchPreprocessor() {
		BasePreprocessor.apply(this);
		this.type = mx.SolutionBuilderAgent.PreprocessorType.Search;
		return this;
	}

	SearchPreprocessor.prototype = angular.extend(Object.create(BasePreprocessor.prototype), {
		build: function () {
			return this.executor.searchBuild();
		},

		callChanged: function () {
			this.changed();
		},

		resetSearch: function () {
			searchService.resetSearch();
		},
	});

	return SearchPreprocessor;
}
